import { useState } from 'react';

// material-ui
import { Card } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AreaMensagem from './AreaMensagem';
import ChatFooter from './ChatFooter';
import ChatHead from './ChatHead';

function ModuloChat() {
  const theme = useTheme();
  const [newMessageClient, setNewMessageClient] = useState('');
  const [replyTarget, setReplyTarget] = useState(null);

  const [encerraCampo, setEncerraCampo] = useState(false);

  function bloquearCampo(value) {
    setEncerraCampo(value);
  }

  function encerrarChatHead(value) {
    setEncerraCampo(value);
  }

  return (
    // Aqui é feito a formatação do texto que vai para o chat
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // whiteSpace: pre-line ele funcionou como quebra de linha no chat.
        whiteSpace: 'pre-line',
        height: '95vh',
        boxShadow: theme.shadows[10],
      }}
    >
      <ChatHead
        recebeEncerraChat={(value) => encerrarChatHead(value)}
        encerrarChat={encerraCampo}
      />
      <AreaMensagem
        addMensagemCliente={newMessageClient}
        recebeEncerraChat={(value) => bloquearCampo(value)}
        onReplyMessage={setReplyTarget}
      />
      <ChatFooter
        newMessageClient={(value) => setNewMessageClient(value)}
        encerrarChat={encerraCampo}
        replyTarget={replyTarget}
        onCancelReply={() => setReplyTarget(null)}
      />
    </Card>
  );
}

export default ModuloChat;
